import { render } from "./modal-plus-pass-purchase.vue?vue&type=template&id=6266249c"
import script from "./modal-plus-pass-purchase.vue?vue&type=script&lang=js"
export * from "./modal-plus-pass-purchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__